import { CurrencyInput } from '@/components/ui/currency-input';
import { centsToDollars } from '@/lib/currency';
import type { Trade } from '@/models/registry';
import dayjs from 'dayjs';
import { noop } from 'lodash';
import { useState } from 'react';
import { TradePayoffDialog } from './trade-payoff-dialog';

export function TradePayoffDisplay({ trade }: { trade: Trade }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      <h5 className="scroll-m-20 text-lg  tracking-tight w-full">Payoff</h5>

      <div className="flex flex-col gap-1">
        <div className="flex flex-row justify-between items-center">
          <span className="text-sm text-muted-foreground">Payoff Amount:</span>
          <div onClick={() => setOpen(true)}>
            <CurrencyInput
              value={centsToDollars(trade.payoff_amount || 0)}
              onChange={noop}
              readOnly
              placeholder="0.00"
              className="text-right w-16"
            />
          </div>
        </div>
        <div className="flex flex-row justify-between items-center">
          <div className="text-sm text-muted-foreground">
            Payoff Expiration:
          </div>
          <div className="text-gray-500" onClick={() => setOpen(true)}>
            {trade.payoff_expiration
              ? dayjs(trade.payoff_expiration).format('MMM D')
              : '-'}
          </div>
        </div>
      </div>
      <TradePayoffDialog
        trade={trade}
        open={open}
        setOpen={setOpen}
      ></TradePayoffDialog>
    </div>
  );
}
